import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PaymentComponent } from './payment/payment.component';
import { PaymentStripeComponent } from './payment/providers/stripe/payment-stripe.component';
import { PaymentCieloComponent } from './payment/providers/cielo/payment-cielo.component';
import { PaymentPixComponent } from './payment/providers/pix/payment-pix.component';
import { PaymentBoletoComponent } from './payment/providers/boleto/payment-boleto.component';
import { DetailsComponent } from './details/details.component';
import { SharedModule } from './@shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAnalyticsModule } from '@angular/fire/compat/analytics';
registerLocaleData(localePt, 'pt-BR');

@NgModule({
  declarations: [
    AppComponent,
    PaymentComponent,
    PaymentStripeComponent,
    PaymentCieloComponent,
    PaymentPixComponent,
    PaymentBoletoComponent,
    DetailsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    SweetAlert2Module.forRoot(),
    ReactiveFormsModule,
    ClipboardModule,
    NgxMaskDirective,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAnalyticsModule,
  ],
  providers: [provideNgxMask(), { provide: LOCALE_ID, useValue: 'pt-BR' }],
  bootstrap: [AppComponent],
})
export class AppModule {}
